import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import React from 'react';

import * as ST from './styled';

const PopupContentForError = (
    {
        errorText,
        onClose,
    },
) => {
    return (
        <ST.PopupWrapper>
            <ST.PopupTitle
                color={ST.POPUP_TITLE_ERROR_COLOR}
            >
                Произошла ошибка
            </ST.PopupTitle>

            <ST.PopupText>
                {errorText}
            </ST.PopupText>

            <ST.PopupButtonsWrapper>

                <ST.PopupButton
                    onClick={onClose}
                    type={btnTypes.SECONDARY}
                >
                    Закрыть
                </ST.PopupButton>
            </ST.PopupButtonsWrapper>
        </ST.PopupWrapper>
    );
};

export default PopupContentForError;
